import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";

import {TranslateModule} from '@ngx-translate/core';
import {StartComponent} from "./start.component";
import {CatComponent} from "./cat.component";
import {TextCaruselComponent} from "./text.carusel.component";
import {StartRoutingModule} from "./start-routing.module";

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        StartRoutingModule
    ],
    declarations: [
        StartComponent,
        CatComponent,
        TextCaruselComponent
    ]
})
export class StartModule {
}
